import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex justify-between flex-wrap gap-x-2 gap-y-2 mb-4" }
const _hoisted_2 = { class: "flex items-center flex-wrap gap-x-2 gap-y-2" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }

import { useFiltersStore } from '../stores/filters';
import { getTranslation } from '@/js/helpers/translation';
import FilterBadge from '@/js/components/FilterBadge.vue';
import { getFilterType } from '@/js/helpers/filters';


export default /*@__PURE__*/_defineComponent({
  __name: 'ActiveFilters',
  setup(__props) {

const store = useFiltersStore();

function getFormattedFilterValue(value: any) {
  if (value === null) {
    return;
  }

  const filterType = getFilterType(value);
  if (filterType == 'category') {
    return value.map((item: FilterOption) => item.title).join(', ')
  }

  if (filterType == 'number') {
    return `${value}+`
  }

  if (filterType == 'range') {
    return `${value.min == null ? '0' : value.min}${value.max === null ? '+' : '-'}${value.max === null ? '' : value.max}`;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(store).searchQuery !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(FilterBadge, {
              label: "Søk",
              value: _unref(store).searchQuery,
              onRemove: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).searchQuery = null))
            }, null, 8, ["value"])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).filterSections, (section) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: section.id
        }, [
          _createVNode(FilterBadge, {
            label: section.title,
            value: getFormattedFilterValue(_unref(store).filters[section.productFieldHandle]),
            onRemove: ($event: any) => (_unref(store).resetFilter(section.productFieldHandle))
          }, null, 8, ["label", "value", "onRemove"])
        ])), [
          [_vShow, _unref(store).filters[section.productFieldHandle] !== null]
        ])
      }), 128))
    ]),
    (_unref(store).searchQuery !== null || _unref(store).isAnyFilterActive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_unref(store).resetAllFilters && _unref(store).resetAllFilters(...args)), ["prevent"])),
            class: "underline text-teal"
          }, "Tilbakestill filter")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})